import Rule from "../../../../common/rule";
import FootballState from "../../../state/football-state";

export default class PatTurnoverPointsAwarded extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            ruleContext.PAT &&
            fragment.associatedState === FootballState.PatPointsAwarded
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const patFragment =
            play.getFirstFragment(FootballState.PatReturned) ||
            play.getFirstFragment(FootballState.PatContinued);
        const tdTeamId = gameContext?.currentPlayerInPossession?.teamId;
        const possessionTeamId =
            patFragment?.returnedBy?.teamId || patFragment?.continuedBy?.teamId;
        gameContext.setPossessionForTeamId(possessionTeamId);
        const points = gameContext?.gameConfig?.scoring?.runPAT || 0;
        gameContext.increaseTeamPossessionScore(points);
        ruleContext.playPoints = points;
        gameContext.setPossessionForTeamId(tdTeamId);
    }
}
